import { useState } from "react";
import { Tooltip } from "antd";
import "./Calendar.css";

const Calendar = () => {
  const today = new Date();

  const [currentDate, setCurrentDate] = useState(
    new Date(today.getFullYear(), today.getMonth(), 1)
  );

  const [activeDay, setActiveDay] = useState(null);

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const startDay = new Date(year, month, 1).getDay();

  const prevMonth = () => setCurrentDate(new Date(year, month - 1, 1));
  const nextMonth = () => setCurrentDate(new Date(year, month + 1, 1));

  const handleDayClick = (day) => {
    setActiveDay(day);

    // auto-hide tooltip
    setTimeout(() => {
      setActiveDay(null);
    }, 1500);
  };

  return (
    <div className="calendar">
      {/* Header */}
      <div className="calendar-header">
        <button onClick={prevMonth}>‹</button>

        <span>
          {currentDate.toLocaleString("default", {
            month: "long",
            year: "numeric",
          })}
        </span>

        <button onClick={nextMonth}>›</button>
      </div>

      {/* Grid */}
      <div className="calendar-grid">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => (
          <div key={d} className="calendar-day-label">
            {d}
          </div>
        ))}

        {/* Empty slots */}
        {Array.from({ length: startDay }).map((_, i) => (
          <div key={`empty-${i}`} />
        ))}

        {/* Days */}
        {Array.from({ length: daysInMonth }).map((_, i) => {
          const day = i + 1;
          const isToday =
            day === today.getDate() &&
            month === today.getMonth() &&
            year === today.getFullYear();

          return (
            <Tooltip
              key={day}
              title="It's just pretty. Shoot me an email instead!"
              open={activeDay === day}
              placement="top"
            >
              <div
                className={`calendar-day ${isToday ? "today" : ""}`}
                onClick={() => handleDayClick(day)}
              >
                {day}
              </div>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};

export default Calendar;